<template>
    <div
        class="flex w-full flex-wrap items-center justify-end gap-2 py-1"
        aria-live="polite"
    >
        <a
            v-if="activeCta"
            :href="activeCta.url"
            :title="activeCta.title"
            :aria-label="activeCta.title"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex shrink-0 items-center justify-center rounded-md border-2 border-player-contrast bg-transparent px-3 py-1.5 text-sm font-medium leading-none text-player-contrast hover:bg-player-contrast hover:text-player-background focus:outline-none focus:ring-2 focus:ring-player-accent focus:ring-offset-2 focus:ring-offset-player-background disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
            @click="emit('clicked', activeCta?.id)"
        >
            {{ activeCta.button }}
        </a>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { resolveActiveCta } from "../helpers.js";

const props = defineProps({
    ctas: {
        type: Array,
        required: true,
    },
    seek: {
        type: Number,
        required: true,
    },
});

const emit = defineEmits(["clicked"]);

const activeCta = computed(() => resolveActiveCta(props.seek, props.ctas));
</script>
